<template>
    <v-container fluid class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="10" class="mx-auto" style="position:relative; top: -40px">
                <v-card>
                    <v-card-text>
                        <v-data-table
                            :headers="headers"
                            :items="languages"
                            :loading="loading_table"
                            :footer-props="footer_props"
                            :loading-text="loading_text"
                            :no-data-text="no_data_text"
                            :no-results-text="no_result_text"
                            :search="search"
                        >
                            <template v-slot:top>
                                <v-container class="py-0">
                                    <v-row justify="center" align="center">
                                        <v-col cols="12" lg="10">
                                            <v-text-field
                                                v-model="search"
                                                clearable
                                                dense
                                                outlined
                                                hide-details
                                                label="Buscar"
                                                append-icon="mdi-magnify"
                                                color="#818181"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>

                            <template v-slot:item.image="{ item }">
                                <v-img :src="image_url+item.image" width="35" height="35" style="border-radius: 50%"></v-img>
                            </template>

                            <template v-slot:item.total_questions="{ item }">
                                <template v-if="item.exam   ">
                                    {{ JSON.parse(item.exam.questions).length }}
                                </template>
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon>mdi-menu</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text v-if="item.exam" :href="edit_url+item.exam.id+'/edit'">Editar</v-btn>
                                            <v-btn small text v-else @click="() => { language_id = item.id; new_exam = true }">Crear</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="px-0" v-if="item.exam">
                                        <v-list-item-content>
                                            <v-btn small text @click="() => { show_item = item; show_dialog = true }">Mostrar</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="new_exam" max-width="800" persistent>
            <v-card>
                <v-card-title>Nuevo examen de ubicación</v-card-title>
                <v-card-text>
                    <v-form ref="new_exam_form">
                        <v-text-field v-model="name" :rules="[rules.required]" filled label="nombre del examen"></v-text-field>
                        <v-textarea v-model="description" filled label="Descripción (Opcional)"></v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" @click="() => { new_exam = false; $refs.new_exam_form.reset() }" :disabled="loading">Cerrar</v-btn>
                    <v-btn color="#008dd4" dark @click="submit" :loading="loading">Registrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <show :dialog="show_dialog" :language="show_item"></show>
    </v-container>
</template>
<script>

import show from './show.vue'
import iziToast from 'izitoast'

export default {
    props:['languages'],
    components:{
        show
    },
    data: () => ({
        new_exam:false,
        post_url:"/placement-exams/store",
        edit_url:"/placement-exams/",

        rules:{
            required: v => !!v || 'El campo es requerido',
        },

        loading:false,

        image_url:"/storage/langs_disk/",

        name:"",
        description:"",
        language_id:"",

        //data table props
        color:"#818181",
        search:"",
        loading_table:false,
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        headers:[
            { text:'#', value:'image' },
            { text:'Código', value:"code" },
            { text:'Idioma', value:'language' },
            { text:'Nombre', value:'exam.title' },
            { text:'Preguntas', value:'total_questions' },
            { text: 'Acciones', value:'actions', sorteable:false},
        ],
        footer_props:{
            itemsPerPageText:"Filas por página",
            showCurrentPage:true,
            itemsPerPageAllText:"Todo",
            showFirstLastPage:true,
        },

        //show dialog
        show_dialog:false,
        show_item:"",
    }),

    methods:{
        submit:function()
        {
            if(this.$refs.new_exam_form.validate()){
                let data = {}
                data.name        = this.name
                data.language_id = this.language_id
                data.description = this.description

                this.loading = true

                axios.post(this.post_url, data).then(response => { window.location.href = response.data.url})
                .catch(error => {
                    this.loading = false
                    iziToast.error({
                        title:"Error",
                        message:"Ha ocurrido un error en la comunicación con el servidor",
                        position:"topRight"
                    })
                })
            }
        }
    }
}
</script>